export const CISCO_TIMEZONE_MAP: Record<number, string> = {
  0: '(GMT+12:00) Pacific/Wake',
  1: '(GMT-11:00) Pacific/Pago_Pago',
  2: '(GMT-10:00) Pacific/Honolulu',
  3: '(GMT-09:00) America/Anchorage',
  4: '(GMT-08:00) America/Los_Angeles',
  10: '(GMT-07:00) America/Denver',
  13: '(GMT-07:00) America/Mazatlan',
  15: '(GMT-07:00) America/Phoenix',
  20: '(GMT-06:00) America/Chicago',
  25: '(GMT-06:00) America/Regina',
  30: '(GMT-06:00) America/Mexico_City',
  33: '(GMT-06:00) America/Costa_Rica',
  35: '(GMT-05:00) America/New_York',
  40: '(GMT-05:00) America/Indiana/Indianapolis',
  45: '(GMT-05:00) America/Lima',
  50: '(GMT-04:00) America/Halifax',
  55: '(GMT-04:00) America/La_Paz',
  56: '(GMT-04:00) America/Santiago',
  60: '(GMT-03:30) America/St_Johns',
  65: '(GMT-03:00) America/Sao_Paulo',
  70: '(GMT-04:00) America/Guyana',
  75: '(GMT-02:00) Atlantic/South_Georgia',
  80: '(GMT-01:00) Atlantic/Azores',
  83: '(GMT-01:00) Atlantic/Cape_Verde',
  85: '(GMT-00:00) Europe/London',
  90: '(GMT-00:00) Africa/Monrovia',
  95: '(GMT+01:00) Europe/Belgrade',
  100: '(GMT+01:00) Europe/Warsaw',
  105: '(GMT+01:00) Europe/Paris',
  110: '(GMT+01:00) Europe/Zurich',
  113: '(GMT+01:00) Africa/Algiers',
  115: '(GMT+02:00) Europe/Bucharest',
  120: '(GMT+02:00) Africa/Cairo',
  125: '(GMT+02:00) Europe/Helsinki',
  130: '(GMT+02:00) Europe/Athens',
  135: '(GMT+02:00) Asia/Jerusalem',
  140: '(GMT+02:00) Africa/Johannesburg',
  145: '(GMT+03:00) Europe/Moscow',
  150: '(GMT+03:00) Asia/Kuwait',
  155: '(GMT+03:00) Africa/Nairobi',
  158: '(GMT+03:00) Asia/Baghdad',
  160: '(GMT+03:30) Asia/Tehran',
  165: '(GMT+04:00) Asia/Dubai',
  170: '(GMT+04:00) Asia/Yerevan',
  175: '(GMT+04:30) Asia/Kabul',
  180: '(GMT+06:00) Asia/Yekaterinburg',
  185: '(GMT+05:00) Asia/Tashkent',
  190: '(GMT+05:30) Asia/Kolkata',
  195: '(GMT+06:00) Asia/Dhaka',
  200: '(GMT+05:30) Asia/Colombo',
  201: '(GMT+07:00) Asia/Novosibirsk',
  205: '(GMT+07:00) Asia/Bangkok',
  207: '(GMT+08:00) Asia/Krasnoyarsk',
  210: '(GMT+08:00) Asia/Hong_Kong',
  215: '(GMT+08:00) Asia/Kuala_Lumpur',
  220: '(GMT+08:00) Asia/Taipei',
  225: '(GMT+08:00) Australia/Perth',
  227: '(GMT+09:00) Asia/Irkutsk',
  230: '(GMT+09:00) Asia/Seoul',
  235: '(GMT+09:00) Asia/Tokyo',
  240: '(GMT+10:00) Asia/Yakutsk',
  245: '(GMT+09:30) Australia/Darwin',
  250: '(GMT+09:30) Australia/Adelaide',
  255: '(GMT+10:00) Australia/Sydney',
  260: '(GMT+10:00) Australia/Brisbane',
  265: '(GMT+10:00) Australia/Hobart',
  270: '(GMT+11:00) Asia/Vladivostok',
  275: '(GMT+10:00) Pacific/Guam',
  280: '(GMT+12:00) Asia/Magadan',
  285: '(GMT+12:00) Pacific/Fiji',
  290: '(GMT+12:00) Pacific/Auckland',
  300: '(GMT+13:00) Pacific/Tongatapu',
  99990: '(GMT-04:30) America/Caracas',
  99991: '(GMT-03:00) America/Argentina/Buenos_Aires',
  100000: '(GMT-00:00) Africa/Abidjan',
  100001: '(GMT-00:00) Africa/Accra',
  100002: '(GMT+03:00) Africa/Addis_Ababa',
  100003: '(GMT+03:00) Africa/Asmara',
  100004: '(GMT-00:00) Africa/Bamako',
  100005: '(GMT+01:00) Africa/Bangui',
  100006: '(GMT-00:00) Africa/Banjul',
  100007: '(GMT-00:00) Africa/Bissau',
  100008: '(GMT+02:00) Africa/Blantyre',
  100009: '(GMT+01:00) Africa/Brazzaville',
  100010: '(GMT+02:00) Africa/Bujumbura',
  100011: '(GMT-00:00) Africa/Casablanca',
  100012: '(GMT+01:00) Africa/Ceuta',
  100013: '(GMT-00:00) Africa/Conakry',
  100014: '(GMT-00:00) Africa/Dakar',
  100015: '(GMT+03:00) Africa/Dar_es_Salaam',
  100016: '(GMT+03:00) Africa/Djibouti',
  100017: '(GMT+01:00) Africa/Douala',
  100018: '(GMT-00:00) Africa/El_Aaiun',
  100019: '(GMT-00:00) Africa/Freetown',
  100020: '(GMT+02:00) Africa/Gaborone',
  100021: '(GMT+02:00) Africa/Harare',
  100023: '(GMT+03:00) Africa/Kampala',
  100024: '(GMT+03:00) Africa/Khartoum',
  100025: '(GMT+02:00) Africa/Kigali',
  100026: '(GMT+01:00) Africa/Kinshasa',
  100027: '(GMT+01:00) Africa/Lagos',
  100028: '(GMT+01:00) Africa/Libreville',
  100029: '(GMT-00:00) Africa/Lome',
  100030: '(GMT+01:00) Africa/Luanda',
  100031: '(GMT+02:00) Africa/Lubumbashi',
  100032: '(GMT+02:00) Africa/Lusaka',
  100033: '(GMT+01:00) Africa/Malabo',
  100034: '(GMT+02:00) Africa/Maputo',
  100035: '(GMT+02:00) Africa/Maseru',
  100036: '(GMT+02:00) Africa/Mbabane',
  100037: '(GMT+03:00) Africa/Mogadishu',
  100038: '(GMT+01:00) Africa/Ndjamena',
  100039: '(GMT+01:00) Africa/Niamey',
  100040: '(GMT-00:00) Africa/Nouakchott',
  100041: '(GMT-00:00) Africa/Ouagadougou',
  100042: '(GMT+01:00) Africa/Porto-Novo',
  100043: '(GMT-00:00) Africa/Sao_Tome',
  100044: '(GMT+02:00) Africa/Tripoli',
  100045: '(GMT+01:00) Africa/Tunis',
  100046: '(GMT+01:00) Africa/Windhoek',
  100047: '(GMT-10:00) America/Adak',
  100048: '(GMT-04:00) America/Anguilla',
  100049: '(GMT-04:00) America/Antigua',
  100050: '(GMT-03:00) America/Araguaina',
  100051: '(GMT-03:00) America/Argentina/Catamarca',
  100052: '(GMT-03:00) America/Argentina/Cordoba',
  100053: '(GMT-03:00) America/Argentina/Jujuy',
  100054: '(GMT-03:00) America/Argentina/La_Rioja',
  100055: '(GMT-03:00) America/Argentina/Mendoza',
  100056: '(GMT-03:00) America/Argentina/Rio_Gallegos',
  100058: '(GMT-03:00) America/Argentina/San_Juan',
  100059: '(GMT-03:00) America/Argentina/San_Luis',
  100060: '(GMT-03:00) America/Argentina/Tucuman',
  100061: '(GMT-03:00) America/Argentina/Ushuaia',
  100062: '(GMT-04:00) America/Aruba',
  100063: '(GMT-04:00) America/Asuncion',
  100064: '(GMT-05:00) America/Atikokan',
  100065: '(GMT-03:00) America/Bahia',
  100067: '(GMT-04:00) America/Barbados',
  100068: '(GMT-03:00) America/Belem',
  100069: '(GMT-06:00) America/Belize',
  100070: '(GMT-04:00) America/Blanc-Sablon',
  100071: '(GMT-04:00) America/Boa_Vista',
  100072: '(GMT-05:00) America/Bogota',
  100073: '(GMT-07:00) America/Boise',
  100074: '(GMT-07:00) America/Cambridge_Bay',
  100075: '(GMT-04:00) America/Campo_Grande',
  100076: '(GMT-06:00) America/Cancun',
  100077: '(GMT-03:00) America/Cayenne',
  100078: '(GMT-05:00) America/Cayman',
  100079: '(GMT-07:00) America/Chihuahua',
  100082: '(GMT-04:00) America/Cuiaba',
  100083: '(GMT-04:00) America/Curacao',
  100084: '(GMT-00:00) America/Danmarkshavn',
  100085: '(GMT-08:00) America/Dawson',
  100086: '(GMT-07:00) America/Dawson_Creek',
  100087: '(GMT-05:00) America/Detroit',
  100088: '(GMT-04:00) America/Dominica',
  100089: '(GMT-07:00) America/Edmonton',
  100090: '(GMT-04:00) America/Eirunepe',
  100091: '(GMT-06:00) America/El_Salvador',
  100092: '(GMT-03:00) America/Fortaleza',
  100094: '(GMT-04:00) America/Glace_Bay',
  100095: '(GMT-04:00) America/Goose_Bay',
  100096: '(GMT-05:00) America/Grand_Turk',
  100097: '(GMT-04:00) America/Grenada',
  100098: '(GMT-04:00) America/Guadeloupe',
  100099: '(GMT-06:00) America/Guatemala',
  100100: '(GMT-05:00) America/Guayaquil',
  100101: '(GMT-05:00) America/Havana',
  100102: '(GMT-07:00) America/Hermosillo',
  100103: '(GMT-06:00) America/Indiana/Knox',
  100104: '(GMT-05:00) America/Indiana/Marengo',
  100105: '(GMT-05:00) America/Indiana/Petersburg',
  100106: '(GMT-06:00) America/Indiana/Tell_City',
  100107: '(GMT-05:00) America/Indiana/Vevay',
  100108: '(GMT-05:00) America/Indiana/Vincennes',
  100109: '(GMT-05:00) America/Indiana/Winamac',
  100110: '(GMT-07:00) America/Inuvik',
  100111: '(GMT-05:00) America/Iqaluit',
  100112: '(GMT-05:00) America/Jamaica',
  100113: '(GMT-09:00) America/Juneau',
  100114: '(GMT-05:00) America/Kentucky/Louisville',
  100115: '(GMT-05:00) America/Kentucky/Monticello',
  100116: '(GMT-04:00) America/Kralendijk',
  100117: '(GMT-04:00) America/Lower_Princes',
  100118: '(GMT-03:00) America/Maceio',
  100119: '(GMT-06:00) America/Managua',
  100120: '(GMT-04:00) America/Manaus',
  100121: '(GMT-04:00) America/Marigot',
  100122: '(GMT-04:00) America/Martinique',
  100124: '(GMT-06:00) America/Menominee',
  100125: '(GMT-06:00) America/Merida',
  100126: '(GMT-08:00) America/Metlakatla',
  100127: '(GMT-03:00) America/Miquelon',
  100128: '(GMT-04:00) America/Moncton',
  100129: '(GMT-06:00) America/Monterrey',
  100130: '(GMT-03:00) America/Montevideo',
  100131: '(GMT-04:00) America/Montserrat',
  100132: '(GMT-05:00) America/Nassau',
  100133: '(GMT-05:00) America/Nipigon',
  100134: '(GMT-09:00) America/Nome',
  100135: '(GMT-02:00) America/Noronha',
  100136: '(GMT-06:00) America/North_Dakota/Beulah',
  100137: '(GMT-06:00) America/North_Dakota/Center',
  100138: '(GMT-06:00) America/North_Dakota/New_Salem',
  100140: '(GMT-05:00) America/Panama',
  100141: '(GMT-05:00) America/Pangnirtung',
  100142: '(GMT-03:00) America/Paramaribo',
  100143: '(GMT-05:00) America/Port-au-Prince',
  100144: '(GMT-04:00) America/Port_of_Spain',
  100145: '(GMT-04:00) America/Porto_Velho',
  100146: '(GMT-04:00) America/Puerto_Rico',
  100148: '(GMT-06:00) America/Rainy_River',
  100149: '(GMT-06:00) America/Rankin_Inlet',
  100150: '(GMT-03:00) America/Recife',
  100151: '(GMT-05:00) America/Resolute',
  100152: '(GMT-04:00) America/Rio_Branco',
  100154: '(GMT-04:00) America/Santo_Domingo',
  100155: '(GMT-01:00) America/Scoresbysund',
  100156: '(GMT-09:00) America/Sitka',
  100157: '(GMT-04:00) America/St_Barthelemy',
  100158: '(GMT-04:00) America/St_Kitts',
  100159: '(GMT-04:00) America/St_Lucia',
  100160: '(GMT-04:00) America/St_Thomas',
  100161: '(GMT-04:00) America/St_Vincent',
  100162: '(GMT-06:00) America/Swift_Current',
  100163: '(GMT-06:00) America/Tegucigalpa',
  100164: '(GMT-04:00) America/Thule',
  100165: '(GMT-05:00) America/Thunder_Bay',
  100166: '(GMT-08:00) America/Tijuana',
  100167: '(GMT-05:00) America/Toronto',
  100168: '(GMT-04:00) America/Tortola',
  100169: '(GMT-08:00) America/Vancouver',
  100170: '(GMT-08:00) America/Whitehorse',
  100171: '(GMT-06:00) America/Winnipeg',
  100172: '(GMT-09:00) America/Yakutat',
  100173: '(GMT-07:00) America/Yellowknife',
  100174: '(GMT+08:00) Antarctica/Casey',
  100175: '(GMT+07:00) Antarctica/Davis',
  100176: '(GMT+10:00) Antarctica/DumontDUrville',
  100178: '(GMT+06:00) Antarctica/Mawson',
  100179: '(GMT+12:00) Antarctica/McMurdo',
  100180: '(GMT-04:00) Antarctica/Palmer',
  100181: '(GMT-03:00) Antarctica/Rothera',
  100182: '(GMT+03:00) Antarctica/Syowa',
  100184: '(GMT+06:00) Antarctica/Vostok',
  100185: '(GMT+01:00) Arctic/Longyearbyen',
  100186: '(GMT+03:00) Asia/Aden',
  100187: '(GMT+06:00) Asia/Almaty',
  100188: '(GMT+02:00) Asia/Amman',
  100189: '(GMT+12:00) Asia/Anadyr',
  100190: '(GMT+05:00) Asia/Aqtau',
  100191: '(GMT+05:00) Asia/Aqtobe',
  100192: '(GMT+05:00) Asia/Ashgabat',
  100194: '(GMT+03:00) Asia/Bahrain',
  100195: '(GMT+04:00) Asia/Baku',
  100197: '(GMT+02:00) Asia/Beirut',
  100198: '(GMT+06:00) Asia/Bishkek',
  100199: '(GMT+08:00) Asia/Brunei',
  100201: '(GMT+08:00) Asia/Choibalsan',
  100202: '(GMT+02:00) Asia/Damascus',
  100203: '(GMT+09:00) Asia/Dili',
  100204: '(GMT+05:00) Asia/Dushanbe',
  100206: '(GMT+02:00) Asia/Gaza',
  100208: '(GMT+07:00) Asia/Ho_Chi_Minh',
  100209: '(GMT+07:00) Asia/Hovd',
  100210: '(GMT+02:00) Asia/Istanbul',
  100211: '(GMT+07:00) Asia/Jakarta',
  100212: '(GMT+09:00) Asia/Jayapura',
  100213: '(GMT+12:00) Asia/Kamchatka',
  100214: '(GMT+05:00) Asia/Karachi',
  100216: '(GMT+08:00) Asia/Kuching',
  100217: '(GMT+08:00) Asia/Macau',
  100218: '(GMT+08:00) Asia/Makassar',
  100219: '(GMT+08:00) Asia/Manila',
  100220: '(GMT+04:00) Asia/Muscat',
  100221: '(GMT+02:00) Asia/Nicosia',
  100222: '(GMT+07:00) Asia/Novokuznetsk',
  100223: '(GMT+07:00) Asia/Omsk',
  100224: '(GMT+05:00) Asia/Oral',
  100225: '(GMT+07:00) Asia/Phnom_Penh',
  100226: '(GMT+07:00) Asia/Pontianak',
  100227: '(GMT+09:00) Asia/Pyongyang',
  100228: '(GMT+03:00) Asia/Qatar',
  100230: '(GMT+06:00) Asia/Qyzylorda',
  100231: '(GMT+03:00) Asia/Riyadh',
  100232: '(GMT+11:00) Asia/Sakhalin',
  100233: '(GMT+05:00) Asia/Samarkand',
  100234: '(GMT+08:00) Asia/Shanghai',
  100235: '(GMT+08:00) Asia/Singapore',
  100237: '(GMT+04:00) Asia/Tbilisi',
  100238: '(GMT+06:00) Asia/Thimphu',
  100240: '(GMT+08:00) Asia/Ulaanbaatar',
  100241: '(GMT+08:00) Asia/Urumqi',
  100243: '(GMT+07:00) Asia/Vientiane',
  100244: '(GMT-04:00) Atlantic/Bermuda',
  100245: '(GMT-00:00) Atlantic/Canary',
  100246: '(GMT-00:00) Atlantic/Faroe',
  100247: '(GMT-00:00) Atlantic/Madeira',
  100248: '(GMT-00:00) Atlantic/Reykjavik',
  100249: '(GMT-03:00) Atlantic/Stanley',
  100250: '(GMT-00:00) Atlantic/St_Helena',
  100251: '(GMT+09:30) Australia/Broken_Hill',
  100252: '(GMT+08:45) Australia/Eucla',
  100253: '(GMT+10:00) Australia/Lindeman',
  100254: '(GMT+10:30) Australia/Lord_Howe',
  100255: '(GMT+10:00) Australia/Melbourne',
  100256: '(GMT+01:00) CET',
  100257: '(GMT-06:00) CST6CDT',
  100258: '(GMT+02:00) EET',
  100259: '(GMT-05:00) EST',
  100260: '(GMT-05:00) EST5EDT',
  100261: '(GMT-00:00) Etc/GMT',
  100262: '(GMT-00:00) Etc/GMT+0',
  100263: '(GMT-00:00) Etc/GMT-0',
  100264: '(GMT-00:00) Etc/GMT0',
  100265: '(GMT-01:00) Etc/GMT+1',
  100266: '(GMT+01:00) Etc/GMT-1',
  100267: '(GMT-10:00) Etc/GMT+10',
  100268: '(GMT+10:00) Etc/GMT-10',
  100269: '(GMT-11:00) Etc/GMT+11',
  100270: '(GMT+11:00) Etc/GMT-11',
  100271: '(GMT-12:00) Etc/GMT+12',
  100272: '(GMT+12:00) Etc/GMT-12',
  100273: '(GMT+13:00) Etc/GMT-13',
  100274: '(GMT+14:00) Etc/GMT-14',
  100275: '(GMT-02:00) Etc/GMT+2',
  100276: '(GMT+02:00) Etc/GMT-2',
  100277: '(GMT-03:00) Etc/GMT+3',
  100278: '(GMT+03:00) Etc/GMT-3',
  100279: '(GMT-04:00) Etc/GMT+4',
  100280: '(GMT+04:00) Etc/GMT-4',
  100281: '(GMT-05:00) Etc/GMT+5',
  100282: '(GMT+05:00) Etc/GMT-5',
  100283: '(GMT-06:00) Etc/GMT+6',
  100284: '(GMT+06:00) Etc/GMT-6',
  100285: '(GMT-07:00) Etc/GMT+7',
  100286: '(GMT+07:00) Etc/GMT-7',
  100287: '(GMT-08:00) Etc/GMT+8',
  100288: '(GMT+08:00) Etc/GMT-8',
  100289: '(GMT-09:00) Etc/GMT+9',
  100290: '(GMT+09:00) Etc/GMT-9',
  100291: '(GMT-00:00) Etc/Greenwich',
  100292: '(GMT-00:00) Etc/Universal',
  100293: '(GMT-00:00) Etc/UTC',
  100294: '(GMT-00:00) Etc/Zulu',
  100295: '(GMT+01:00) Europe/Amsterdam',
  100296: '(GMT+01:00) Europe/Andorra',
  100298: '(GMT+01:00) Europe/Berlin',
  100299: '(GMT+01:00) Europe/Bratislava',
  100300: '(GMT+01:00) Europe/Brussels',
  100301: '(GMT+01:00) Europe/Budapest',
  100303: '(GMT+02:00) Europe/Chisinau',
  100304: '(GMT+01:00) Europe/Copenhagen',
  100305: '(GMT-00:00) Europe/Dublin',
  100306: '(GMT+01:00) Europe/Gibraltar',
  100307: '(GMT-00:00) Europe/Guernsey',
  100308: '(GMT-00:00) Europe/Isle_of_Man',
  100309: '(GMT+02:00) Europe/Istanbul',
  100310: '(GMT-00:00) Europe/Jersey',
  100311: '(GMT+02:00) Europe/Kaliningrad',
  100314: '(GMT-00:00) Europe/Lisbon',
  100315: '(GMT+01:00) Europe/Ljubljana',
  100316: '(GMT+01:00) Europe/Luxembourg',
  100317: '(GMT+01:00) Europe/Madrid',
  100318: '(GMT+01:00) Europe/Malta',
  100319: '(GMT+02:00) Europe/Mariehamn',
  100320: '(GMT+02:00) Europe/Minsk',
  100321: '(GMT+01:00) Europe/Monaco',
  100322: '(GMT+02:00) Europe/Nicosia',
  100323: '(GMT+01:00) Europe/Oslo',
  100324: '(GMT+01:00) Europe/Podgorica',
  100325: '(GMT+01:00) Europe/Prague',
  100326: '(GMT+02:00) Europe/Riga',
  100327: '(GMT+01:00) Europe/Rome',
  100328: '(GMT+04:00) Europe/Samara',
  100329: '(GMT+01:00) Europe/San_Marino',
  100330: '(GMT+01:00) Europe/Sarajevo',
  100332: '(GMT+02:00) Europe/Simferopol',
  100333: '(GMT+01:00) Europe/Skopje',
  100334: '(GMT+02:00) Europe/Sofia',
  100335: '(GMT+01:00) Europe/Stockholm',
  100336: '(GMT+02:00) Europe/Tallinn',
  100337: '(GMT+01:00) Europe/Tirane',
  100339: '(GMT+02:00) Europe/Uzhgorod',
  100340: '(GMT+01:00) Europe/Vaduz',
  100341: '(GMT+01:00) Europe/Vatican',
  100342: '(GMT+01:00) Europe/Vienna',
  100343: '(GMT+02:00) Europe/Vilnius',
  100344: '(GMT+04:00) Europe/Volgograd',
  100345: '(GMT+01:00) Europe/Zagreb',
  100346: '(GMT+02:00) Europe/Zaporozhye',
  100347: '(GMT-00:00) GMT',
  100348: '(GMT-10:00) HST',
  100349: '(GMT+03:00) Indian/Antananarivo',
  100350: '(GMT+06:00) Indian/Chagos',
  100351: '(GMT+07:00) Indian/Christmas',
  100352: '(GMT+06:30) Indian/Cocos',
  100353: '(GMT+03:00) Indian/Comoro',
  100354: '(GMT+05:00) Indian/Kerguelen',
  100355: '(GMT+04:00) Indian/Mahe',
  100356: '(GMT+05:00) Indian/Maldives',
  100357: '(GMT+04:00) Indian/Mauritius',
  100358: '(GMT+03:00) Indian/Mayotte',
  100359: '(GMT+04:00) Indian/Reunion',
  100360: '(GMT+01:00) MET',
  100361: '(GMT-07:00) MST',
  100362: '(GMT-07:00) MST7MDT',
  100363: '(GMT-11:00) Pacific/Apia',
  100365: '(GMT+12:45) Pacific/Chatham',
  100367: '(GMT-06:00) Pacific/Easter',
  100368: '(GMT+11:00) Pacific/Efate',
  100369: '(GMT-10:00) Pacific/Fakaofo',
  100370: '(GMT+12:00) Pacific/Funafuti',
  100371: '(GMT-06:00) Pacific/Galapagos',
  100372: '(GMT-09:00) Pacific/Gambier',
  100373: '(GMT+11:00) Pacific/Guadalcanal',
  100375: '(GMT+14:00) Pacific/Kiritimati',
  100376: '(GMT+11:00) Pacific/Kosrae',
  100377: '(GMT+12:00) Pacific/Kwajalein',
  100378: '(GMT+12:00) Pacific/Majuro',
  100379: '(GMT-09:30) Pacific/Marquesas',
  100380: '(GMT-11:00) Pacific/Midway',
  100381: '(GMT+12:00) Pacific/Nauru',
  100382: '(GMT-11:00) Pacific/Niue',
  100383: '(GMT+11:30) Pacific/Norfolk',
  100384: '(GMT+11:00) Pacific/Noumea',
  100385: '(GMT+09:00) Pacific/Palau',
  100386: '(GMT-08:00) Pacific/Pitcairn',
  100388: '(GMT+10:00) Pacific/Port_Moresby',
  100389: '(GMT-10:00) Pacific/Rarotonga',
  100390: '(GMT+10:00) Pacific/Saipan',
  100391: '(GMT-10:00) Pacific/Tahiti',
  100392: '(GMT+12:00) Pacific/Tarawa',
  100393: '(GMT+12:00) Pacific/Wallis',
  100394: '(GMT-08:00) PST8PDT',
  100395: '(GMT-00:00) WET',
};
